module.exports = __webpack_public_path__ + "img/Group 1140one.3008d544.png";